"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@zapier/common-utils");
const react_1 = require("react");
const lodash_1 = require("lodash");
const theme_1 = require("@zapier/theme");
const SamplePicker_1 = __importDefault(require("../../sample/SamplePicker"));
const SearchInput_1 = __importDefault(require("../../SearchInput"));
const SampleDataView_1 = __importDefault(require("../../sample/SampleDataView"));
const utils_1 = require("../../../utils");
const Styles = common_utils_1.labelStyles(__filename, {
    root: {
        border: `1px solid ${theme_1.Colors.grey200}`,
        borderRadius: 10,
        marginTop: 15,
        padding: '10px 10px 0 10px',
    },
    searchInput: {
        marginTop: 10,
    },
    sampleDataView: ({ isContentOverflowing, }) => ({
        marginBottom: isContentOverflowing ? 0 : 10,
        marginTop: 10,
    }),
});
const SampleDataNerdView = (props) => {
    const [query, setQuery] = react_1.useState('');
    const viewNode = react_1.useRef(null);
    const [isContentOverflowing, setIsContentOverflowing] = react_1.useState(false);
    react_1.useEffect(() => {
        if (viewNode && viewNode.current) {
            const containerOffsetHeight = viewNode.current.offsetHeight;
            const containerScrollHeight = viewNode.current.scrollHeight;
            const hasScrollbar = containerScrollHeight > containerOffsetHeight;
            if (hasScrollbar) {
                setIsContentOverflowing(true);
            }
        }
    }, []);
    const onChangeQuery = (q) => {
        setQuery(q);
    };
    const onResetQuery = () => {
        setQuery('');
    };
    const filteredSampleValue = utils_1.deepSearchMap(query, utils_1.objectToMap(lodash_1.get(props.value, 'data', {})), { caseInsensitive: true });
    return (common_utils_1.isolateComponent("div", { css: Styles.root },
        common_utils_1.isolateComponent(SamplePicker_1.default, Object.assign({}, props)),
        common_utils_1.isolateComponent("div", { css: Styles.searchInput },
            common_utils_1.isolateComponent(SearchInput_1.default, { isDisabled: lodash_1.isEmpty(props.samples), onChange: onChangeQuery, onReset: onResetQuery, value: query })),
        common_utils_1.isolateComponent("div", { css: Styles.sampleDataView({ isContentOverflowing }) },
            common_utils_1.isolateComponent(SampleDataView_1.default, { data: filteredSampleValue, viewRef: viewNode }))));
};
exports.default = SampleDataNerdView;
